<template>
  <div>
    <image-cropper :target-width='width' :target-height='height' v-on:inputImage="saveImage" v-on:deleteImage="deleteImage" :isModal="true" :value="image" :showImageName="showImageName">
      <div class="image-cropper">
          <i class="material-icons">add_photo_alternate</i>
      </div>
    </image-cropper>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ImageCropper from './../editor/imageCropper/'

export default {
  name: 'ImagePicker',
  props: {
    id: {
      type: String,
      default: ''
    },
    imageUrl: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 500
    },
    showImageName: {
      type: Boolean,
      default: false
    }
  },
  components: { ImageCropper },
  data: () => ({
    image: null
  }),
  created() {
      this.image = this.imageUrl
  },
  methods: {
    ...mapActions(['storeImage', 'deleteImageFromStore']),
    saveImage(event) {
      const image = new Image()
      image.src = event
      const id = this.id !== '' ? this.id : this.createUUID()
      const imageToStore = {name: `${id}`, base64: event}
      this.storeImage(imageToStore).then((imageUrl) => {
        this.image = imageUrl
        this.$emit('change', imageUrl)
      });
    },
    deleteImage() {
      this.deleteImageFromStore({imageUrl: this.image}).then(() => {
        this.$emit('change', "")
      });
      this.image = ""
    },
    createUUID() {
      var dt = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = (dt + Math.random()*16)%16 | 0;
          dt = Math.floor(dt/16);
          return (c=='x' ? r :(r&0x3|0x8)).toString(16);
      });
      return uuid;
    }
  }

}

</script>